import { ChainlinkIcon, MastercardIcon } from "@src/assets";

export const PoweredByPanel = () => {
  return (
    <div className="flex flex-row gap-2 justify-center items-center text-sm text-text_primary h-4">
      <p className="text-xs">Powered by</p>
      <MastercardIcon className="w-6" />
      <ChainlinkIcon />
    </div>
  );
};
